import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import idx from 'idx';
import truncate from 'lodash/truncate';
import partial from 'lodash/partial';
import Thumbnail from 'common/components/thumbnail';
import Utils from 'focus_groups/utils';

const VotingTile = ({
  revision, votes, id, onClick, participantId, showAverage, entry_number, author_username, children
}) => {
  const comment = idx(votes, _ => _[participantId].comment);
  const click = partial(onClick, id);
  const { averageScore, numVotes, thumbnailImage } = Utils({ votes, revision });

  return (
    <div className="column">
      <p className="revision-author">
        <span className="entry-number">
          #{ entry_number }
        </span> by {' '}
        <Link to={`/users/${author_username}/`} target="_blank">
          { truncate(author_username, { length: 25 }) }
        </Link>
      </p>

      <div className="tile entry-tile">
        <Thumbnail className="entry-thumbnail" image={thumbnailImage} onClick={click}/>
      </div>

      { comment && false && <div className="voter-comment">{ comment }</div>}

      { showAverage &&
      <div className="focus-group-stats tile-stats">
        <div className="row small-up-2">
          <div className="column">
            <div className="stat-label">Avg Score</div>
            <div className="stat-value">{ averageScore.toFixed(1) }</div>
          </div>
          <div className="column">
            <div className="stat-label">Votes</div>
            <div className="stat-value">{ numVotes }</div>
          </div>
        </div>
      </div> }

      { children }
    </div>
  );
};

VotingTile.propTypes = {
  id: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  revision: PropTypes.shape({
    image: PropTypes.string,
  }).isRequired,
  votes: PropTypes.object,
  participantId: PropTypes.string,
  entry_number: PropTypes.number,
  author_username: PropTypes.string,
  showAverage: PropTypes.bool
};

export default VotingTile;



// WEBPACK FOOTER //
// ./focus_groups/components/voting_tile.jsx